@if (status.state === 'indeterminate') {
  <svg lucideLoaderCircle class="tab-status-icon lucide-spin"></svg>
}
<div class="tab-status-content">
  <span class="tab-status-text">
    @if (status.failedLink) {
      {{ status.failedLink.prefix }}
      <!-- Pluralize inside the interpolation, not via a separate trailing-"s" element.
           The plural "s" in its own element leaves template whitespace (rendered as
           "resource s"), and Prettier reformats any single-line workaround back into
           that layout. Keep the anchor boundaries butted against the text. -->
      <a class="failed-resource-link" href="javascript:void(0)" role="button"
        >{{ status.failedLink.count }} {{ status.failedLink.count === 1 ? 'resource' : 'resources' }}</a
      >
      {{ status.failedLink.suffix }}
    } @else {
      {{ status.text }}
    }
  </span>
  @if (status.issues.length > 0) {
    <a class="tab-status-issues-link" href="javascript:void(0)" role="button"
      >Review and fix {{ status.issues.length }} {{ status.issues.length === 1 ? 'issue' : 'issues' }}</a
    >
  }
  @if (status.progressTotal > 0) {
    <span class="tab-status-progress">
      <span class="progress-track">
        <span
          class="progress-fill"
          [style.width]="
            status.progressCount >= status.progressTotal
              ? '100%'
              : 'min(' + (status.progressCount / status.progressTotal) * 100 + '%, calc(100% - 3px))'
          "
        ></span>
      </span>
      <span class="progress-label">({{ status.progressCount }} / {{ status.progressTotal }})</span>
    </span>
  }
  @if (status.ratioText) {
    <span class="tab-status-ratio">{{ status.ratioText }}</span>
  }
  @if ($any(status).priorBackupInfo) {
    <span class="tab-status-prior-info">{{ $any(status).priorBackupInfo }}</span>
  }
</div>
